import invite from "./config/invite";
export default [
  {
    path: "/",
    name: "index",
    redirect: "/stystem/invite",
  },
  invite,
];
